import { NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ButtonComponent } from '@banyan/commons/components/button/button.component';
import { PlusMinusButtonComponent } from '@banyan/commons/components/plus-minus-button/plus-minus-button.component';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { AccountService } from '@banyan/features/account/services/account.service';
import { CartV2Service } from '@banyan/features/cart/services/cart-v2.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cart-table-v2',
  templateUrl: './cart-table-v2.component.html',
  styleUrls: ['./cart-table-v2.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ButtonComponent,
    MatTabsModule,
    PlusMinusButtonComponent,
    NgOptimizedImage,
    DefaultCurrencyPipe,
  ],
})
export class CartTableV2Component {
  readonly dataSource = input<any>();
  readonly displayedColumns = input<any>();
  readonly total = input<any>();
  updatingCart: boolean = false;
  currency: string = '';
  accountService = inject(AccountService);
  router = inject(Router);
  cartV2Service = inject(CartV2Service);

  constructor() {
  }

  updateCart(
    productId: number | null,
    lineId: string,
    quantity: number | null,
  ): void {
    this.updatingCart = true;
    this.cartV2Service.updateCart(productId, null, null, null, lineId, quantity ?? null);
  }

  goToCheckout() {
    this.router.navigate(['/protected/checkout']).then();
  }

  goToCart() {
    this.router.navigate(['/protected/cart/V2']).then();
  }
}
